export const getRoomAvailabilityMessageStandard = (allocationsAvailable: string | number): string => {
  return Number(allocationsAvailable) === 1
    ? 'We only have 1 room left at this price!'
    : `We have ${allocationsAvailable} rooms left at this price`;
};

export const getRoomAvailabilityMessageForOffer = (allocationsAvailable: string | number): string => {
  return Number(allocationsAvailable) === 1 ? 'Hurry, we only have 1 room left!' : `We only have ${allocationsAvailable} rooms left`;
};
